import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Standalone, full-page payment success screen. No Nav, no Sidebar.
 * Auto-navigates to /advisor after 3 seconds.
 */
export default function PaymentSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate("/advisor", { replace: true }), 3000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div
      data-testid="payment-success-page"
      style={{
        background: "white",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: "480px" }}>
        <img
          src="/logo.png"
          alt="Unimora AI"
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "14px",
            objectFit: "cover",
            margin: "0 auto",
            display: "block",
          }}
        />
        <h1
          style={{
            fontFamily: "var(--ff-display)",
            fontSize: "44px",
            fontWeight: 700,
            color: "var(--ind)",
            letterSpacing: "-0.025em",
            lineHeight: 1.1,
            margin: "28px 0 0",
          }}
        >
          You&apos;re in.
        </h1>
        <p
          style={{
            fontSize: "17px",
            color: "var(--s900)",
            fontWeight: 600,
            marginTop: "12px",
            lineHeight: 1.45,
          }}
        >
          Full access activated. Welcome to the Decide plan.
        </p>
        <p
          style={{
            fontSize: "14px",
            color: "var(--s500)",
            marginTop: "10px",
            lineHeight: 1.55,
          }}
        >
          Taking you to your dashboard in a moment…
        </p>
        <div
          aria-hidden
          style={{
            width: "26px",
            height: "26px",
            margin: "28px auto 0",
            border: "3px solid rgba(79,70,229,0.18)",
            borderTopColor: "var(--ind)",
            borderRadius: "50%",
            animation: "psSpin 0.9s linear infinite",
          }}
        />
        <style>{`@keyframes psSpin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
